import React from "react";
import "../css/privacy.scss";

function Privacy() {
  return (
    <div className="privacy-page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <div className="content-section">
          <p>
            Cewillow Market respects your privacy. This policy explains what
            information we collect when you browse, contact us or place an order,
            how we use it, and the choices available to you.
          </p>

          <div className="policy-block">
            <h3>Information We Collect</h3>
            <p>
              We may collect your name, email address, delivery and billing
              details, order information, customer-service messages, device data,
              IP address and basic website activity. Payment details are entered
              on the payment provider's page and are not collected in our checkout form.
            </p>
          </div>

          <div className="policy-block">
            <h3>How We Use Information</h3>
            <ul>
              <li>To process, deliver and support your order.</li>
              <li>To prevent fraud, secure the website and meet legal obligations.</li>
              <li>To answer questions and administer returns or refunds.</li>
              <li>To understand website performance and improve our services.</li>
            </ul>
          </div>

          <div className="policy-block">
            <h3>Sharing and Service Providers</h3>
            <p>
              We share only the information reasonably required by providers that
              support payment processing, hosting, order fulfilment, delivery,
              fraud prevention and analytics. We do not sell personal information.
            </p>
          </div>

          <div className="policy-block">
            <h3>International Processing</h3>
            <p>
              Some providers may process information outside your location. Where
              this occurs, we use reasonable contractual and technical safeguards
              appropriate to the information and service involved.
            </p>
          </div>

          <div className="policy-block">
            <h3>Retention and Security</h3>
            <p>
              We retain information only for as long as reasonably necessary for
              orders, customer support, recordkeeping, dispute resolution and legal
              compliance. We use reasonable safeguards, but no internet service can
              guarantee absolute security.
            </p>
          </div>

          <div className="policy-block">
            <h3>Your Choices and Rights</h3>
            <p>
              Depending on your location, you may ask to access, correct, delete or
              restrict use of your personal information. You may also object to
              certain processing. We may need to verify your identity before acting
              on a request.
            </p>
          </div>

          <div className="policy-block">
            <h3>Cookies</h3>
            <p>
              We use essential storage for features such as the shopping cart and
              may use limited performance technologies. Read our Cookie Policy for
              details and browser controls.
            </p>
          </div>

          <div className="policy-block">
            <h3>Children's Privacy</h3>
            <p>
              The website is not directed to children, and we do not knowingly
              collect personal information from children without appropriate consent.
            </p>
          </div>

          <div className="policy-block">
            <h3>Contact and Updates</h3>
            <p>
              The website is operated by Hong Kong Mousheng Tech Limited,
              FLAT 1506, 15/F, CHEUNG FUNG COMM BLDG, 21-25 CHEUNG SHA WAN
              ROAD, SHAM SHUI PO, HONG KONG. For privacy questions, email{" "}
              <a href="mailto:import@cewillowmarket.life">import@cewillowmarket.life</a>.
              We may update this policy when our practices or legal obligations change.
            </p>
            <p>Last updated: September 22, 2026.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
